/** @jsx jsx */
import { css } from '@emotion/react';

import type { Theme } from '@coursera/cds-core';

export const commonStyles = {
  input: css`
    .cds-input-root {
      margin-top: 0 !important;
    }
  `,
  hint: (theme: Theme) => css`
    color: ${theme.palette.gray[600]};
    font-size: 12px;
    line-height: 18px;
    margin-top: 8px;
  `,
};
